// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"190":"docs","191":"oxc-home","208":"oxc-me"}[chunkId] || chunkId) + "." + {"190":"fac0f2a4","191":"cedc52cb","208":"8526d9f9","316":"8c4a31f5"}[chunkId] + ".js";
};